































import { Component, Mixins } from "vue-property-decorator";
import {
  HeaderPane,
} from "../../../../components/panes";

@Component({
  components: {
    HeaderPane,
  }
})
export default class MainMenu extends Mixins() {
  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  openNewFormat(): void {
    this.$openWindow("/EditNewFormat");
  }

  openFormatList(): void {
    this.$openWindow("/ShowFormatList");
  }
}
